import _ from 'lodash'
import game from '@ps/store/workspace/game'
import * as sceneConfigScript from '@ps/bridge/qc/scripts/scene-config'
import * as scene from '@ps/bridge/qc/node/scene'
import { executeAction } from '@ps/workbench/undo-redo'
import {
  getAddSceneAction,
  getRemoveSceneAction,
  getRemovePlaySceneAction,
  getSetSceneIndex,
  getSwitchSceneAction,
  getUpdateSceneConfigScriptAction,
} from '@ps/workbench/undo-redo'
import nodePool from '@ps/bridge/qc/node-pool'
import gameIframe from '@ps/bridge/iframe/iframe'
import * as nodeUtils from '../common/node-utils'
import store from '@ps/store'
import { parseComponent } from '@ps/utils/game'
import { AssetType } from '@ps/utils/config'
import assets from '@ps/bridge/qc/assets'
import { Message } from 'element-ui'
import { getDescendants } from '@ps/bridge/qc/node/utils'
import { sleep } from '@ps/utils/tools'
import {
  getEventsOnNode,
  getEventsToNode,
} from '@ps/store/workbench/visual-program'
import storyboardConfig from '@ps/store/workbench/storyboard/config'
import i18n from '@ps/lang'
import { copyScene } from '@ps/workbench/layer/scene'
import { getSceneUniName, SceneType } from '@ps/bridge/qc/scripts/scene-config'
import {
  checkSceneIsSupportProp,
  isNormalScene,
  isPlayScene,
} from '@ps/bridge/qc/scripts/scene-config'
import { hasSelfDevPermission } from '@ps/permission/workbench'
import { hasBanRemoveNode } from '@ps/utils/cooperation'
import { getEraseNodeInScene } from '@ps/bridge/qc/base'
import { eraseToInit } from '@ps/workbench/undo-redo/module/erase'
import {
  replaceAnimationUuid,
  getNodesLayoutBySceneId,
  getRemoveSceneConfig,
} from '@ps/bridge/qc/node'
import { isIvPage } from '@ps/router/config'
import { suffixSync } from '@ps/store/interactive-video/brain/sync'

function getSceneLackThumb(sceneList, sceneThumbnail) {
  const horizontal = []
  const portrait = []
  sceneList.forEach((scene) => {
    const uuid = scene.uuid
    if (!sceneThumbnail[uuid]) {
      horizontal.push(scene.uuid)
      portrait.push(scene.uuid)
    } else if (
      !sceneThumbnail[uuid].thumbnail.portrait ||
      sceneThumbnail[uuid].thumbnail.portraitDirty
    ) {
      portrait.push(scene.uuid)
    } else if (
      !sceneThumbnail[uuid].thumbnail.horizontal ||
      sceneThumbnail[uuid].thumbnail.horizontalDirty
    ) {
      horizontal.push(scene.uuid)
    }
  })
  return {
    horizontal,
    portrait,
  }
}

function getSceneLackLayout(nodesLayout) {
  const horizontal = []
  const portrait = []
  Object.values(nodesLayout).forEach((item) => {
    if (!item.ldef) horizontal.push(item.sceneId)
    if (!item.pdef) portrait.push(item.sceneId)
  })
  return { portrait, horizontal }
}

export function getSceneNeedCapture({
  nodesLayout,
  sceneList,
  sceneThumbnail,
}) {
  const { horizontal: hLackThumb, portrait: pLackThumb } = getSceneLackThumb(
    sceneList,
    sceneThumbnail,
  )
  const { horizontal: hLackLayout, portrait: pLackLayout } =
    getSceneLackLayout(nodesLayout)
  const horizontal = Array.from(new Set([...hLackThumb, ...hLackLayout]))
    .map((sceneId) => sceneList.find((item) => item.uuid === sceneId))
    .filter(Boolean)
  const portrait = Array.from(new Set([...pLackThumb, ...pLackLayout]))
    .map((sceneId) => sceneList.find((item) => item.uuid === sceneId))
    .filter(Boolean)
  return { horizontal, portrait }
}

export const initSceneUtil = {
  playSmart: async (dispatch) => {
    await store.dispatch('workspace/game/sceneManager/addScene', {
      uniqueName: 'Scene 1',
      isSwitchScene: false,
      record: false,
    })
    await store.dispatch('workspace/game/sceneManager/addScene', {
      uniqueName: 'Scene 2',
      isSwitchScene: false,
      record: false,
    })
  },
  ivEditor: async (dispatch) => {
    await store.dispatch('ivBrain/addBrainItem', {
      uniqueName: 'Scene 1',
      isSwitchScene: false,
      record: false,
    })
  },
}

export default {
  async initScene({ state, commit, dispatch, getters }) {
    const gamePlay = gameIframe.gamePlay
    const getNormalSceneList = () => {
      return gamePlay.children.filter(
        (item) => item.SceneConfig.sceneType === SceneType.NORMAL,
      )
    }
    const normalSceneList = getNormalSceneList()
    if (normalSceneList.length === 0) {
      await initSceneUtil[isIvPage() ? 'ivEditor' : 'playSmart']()
      const hasGlobalScene = gamePlay.children.some((scene) => {
        const sceneConfig = sceneConfigScript.getScript(scene)
        return sceneConfig.sceneType === SceneType.GLOBAL
      })
      if (!hasGlobalScene) {
        // 添加全局场景
        await dispatch('addScene', {
          uniqueName: 'Global Scene',
          isSwitchScene: false,
          record: false,
          sceneType: SceneType.GLOBAL,
        })
      }

      // 切换到第一个场景
      const firstNormalScene = getNormalSceneList()[0]
      await dispatch('switchScene', {
        uuid: firstNormalScene
          ? firstNormalScene.uuid
          : state.sceneList[0].uuid,
        record: false,
      })
    } else {
      if (hasSelfDevPermission()) {
        // psd导入的自研素材如果没有全局场景则补上
        const hasGlobalScene = gamePlay.children.some((scene) => {
          const sceneConfig = sceneConfigScript.getScript(scene)
          return sceneConfig.sceneType === SceneType.GLOBAL
        })
        if (!hasGlobalScene) {
          await dispatch('addScene', {
            uniqueName: 'Global Scene',
            isSwitchScene: false,
            record: false,
            sceneType: SceneType.GLOBAL,
          })
        }
      }
      commit('updateSceneList')
      const isNormMaterial = store.state.workspace.project.isNormMaterial
      const normalScenes =
        checkSceneIsSupportProp('global') && isNormMaterial
          ? getters.normalSceneList
          : state.sceneList
      await dispatch('switchScene', {
        uuid: normalScenes[0].uuid,
        record: false,
      })
    }
    store.dispatch('ivBrain/initBrain')
  },

  /**
   * 添加场景
   * @param uniqueName {string} 场景名字 todo: 改成使用 name
   * @param node {qc.Node} 节点，如果有该节点则直接使用该节点作为场景节点
   * @param index {number} 插入位置
   * @returns {Promise<void>}
   */
  async addScene(
    { state },
    {
      uniqueName,
      index,
      node,
      record = true,
      isSwitchScene = true,
      sceneType = SceneType.NORMAL,
      isBatch = false,
    },
  ) {
    const newNode =
      node ||
      scene.add({
        uniqueName,
      })
    await executeAction({
      action: getAddSceneAction({
        newValue: {
          node: newNode,
          // 如果index为undefined的话，则加载最后面
          index: !_.isUndefined(index) ? index : state.sceneList.length,
          isSwitchScene,
          sceneType,
          isBatch,
        },
        oldValue: {
          node: newNode,
          sceneUuid: state.currentSceneNode ? state.currentSceneNode.uuid : '',
        },
      }),
      record,
    })
    return newNode
  },

  /**
   * 移除场景
   * @param uuid {string}
   * @param record {boolean} 是否记录操作历史
   * @param switchUUID {string} 非必填，没有传参则按照 index 去切换，如果传空字符串，则不切换
   * @param force {boolean} 是否强制删除，无视至少需要一个场景的前置条件
   */
  async removeScene(
    { state },
    { uuid, record = true, switchUUID, force = false },
  ) {
    const node = nodePool.find(uuid)
    // 删除场景前置判断
    if (
      !force &&
      node &&
      isNormalScene(node) &&
      state.sceneList.filter((scene) => isNormalScene(scene)).length <= 1
    ) {
      console.log('至少需要一个场景')
      Message({
        message: i18n.t('workbench.sceneManager.deleteSceneError'),
        type: 'warning',
        duration: 3 * 1000,
      })
      return
    }
    if (hasBanRemoveNode(node)) return

    const currentSceneList = isNormalScene(node)
      ? state.sceneList.filter((scene) => isNormalScene(scene))
      : state.sceneList.filter((scene) => isPlayScene(scene))

    const index = currentSceneList.findIndex((item) => {
      return item.uuid === node.uuid
    })
    // 删除场景，下一个当前场景为删除场景的上一个场景
    // 如果删除第一个场景，则下一个当前场景为删除场景的下一个场景
    const nextActiveSceneIndex = index === 0 ? index + 1 : index - 1
    const nextActiveScene = currentSceneList[nextActiveSceneIndex]
    let nextActiveSceneUUID = nextActiveScene ? nextActiveScene.uuid : ''
    if (typeof switchUUID !== 'undefined') {
      nextActiveSceneUUID = switchUUID
    }
    // 获取场景下的所有节点的坐标
    // 获取到目标为该场景有关的事件
    // 获取该场景下绑定的事件
    await executeAction({
      action: getRemoveSceneAction([
        getRemoveSceneConfig(node, nextActiveSceneUUID),
      ]),
      record,
    })
  },

  /**
   * 切换场景
   * @param uuid {string} 节点id
   * @param record {boolean} 是否记录操作历史
   */
  async switchScene({ state }, { uuid, record = true } = {}) {
    // 连续选中当前场景，只记录一次节点选中历史记录
    if (state.currentSceneNode && uuid === state.currentSceneNode.uuid) {
      record = false
    }
    if (isIvPage()) {
      if (state.currentSceneNode && uuid !== state.currentSceneNode.uuid) {
        // 互动视频检测场景同步
        await suffixSync()
      }
    }
    // 切换场景前擦除组件还原到初始状态
    const eraseNode = getEraseNodeInScene(state.currentSceneNode)
    if (eraseNode) {
      eraseToInit([eraseNode])
    }

    const sceneUuid = _.get(state, 'currentSceneNode.uuid') || ''
    await executeAction({
      action: getSwitchSceneAction({
        newValue: {
          uuid,
        },
        oldValue: {
          uuid: sceneUuid,
        },
      }),
      record,
    })
  },

  /**
   * 复制场景
   * @param uuid 待复制的节点id
   * @param index 新节点插入的位置
   * @returns {Promise<void>}
   */
  async copyScene(
    { state, dispatch, commit },
    { uuid, index, isSwitchScene = true, isBatch = false },
  ) {
    index = _.isNumber(index) && index >= 0 ? index : 0
    const sceneNode = state.sceneList.find((item) => item.uuid === uuid)
    const cloneNode = copyScene({ sceneNode, index })
    // 复制场景节点锁定状态
    store.dispatch('workspace/sceneManager/copyAllLockStatus', {
      sourceNode: sceneNode,
      node: cloneNode,
    })
    await store.dispatch('workspace/game/visualProgram/copySceneVpAst', {
      node: cloneNode,
    })
    // 复制场景时,新节点的动画uuid和builtinId需要替换新的
    const nodeList = getDescendants(cloneNode)
    nodeList.forEach((item) => {
      replaceAnimationUuid(item)
    })
    const newSceneNode = await dispatch('addScene', {
      node: cloneNode,
      index,
      isSwitchScene,
      isBatch,
    })
    return newSceneNode
  },

  // 复制节点时使用，复制源节点所有子孙节点锁定状态到新节点
  copyAllLockStatus({ state, rootState }, { sourceNode, node }) {
    const sourceNodeList = getDescendants(sourceNode, null, true)
    const targetNodeList = getDescendants(node, null, true)
    const lockedNodeUuids = rootState.workspace.game.lockedNodeUuids
    const temp = []
    sourceNodeList.forEach((node, index) => {
      if (lockedNodeUuids.indexOf(node.uuid) > -1) {
        temp.push(targetNodeList[index])
      }
    })
    store.dispatch('workspace/game/lockNode', { nodes: temp })
  },

  /**
   * 更新 ps.SceneConfig
   * @param uuid {string} 节点id
   * @param type {string} 场景类型
   * @param record {boolean}
   * @returns {Promise<void>}
   */
  async updateSceneConfigScript({ state }, { uuid, config, record = true }) {
    const node = nodePool.find(uuid)
    const sceneConfig = sceneConfigScript.getScript(node)
    executeAction({
      action: getUpdateSceneConfigScriptAction({
        newValue: {
          node,
          config: {
            ...config,
          },
        },
        oldValue: {
          node,
          config: {
            ...sceneConfig,
          },
        },
      }),
      record,
    })
  },

  setSceneIndex({ state, commit }, { uuid, index, oldIndex, record = true }) {
    const node = state.sceneList.find((item) => item.uuid === uuid)
    executeAction({
      action: getSetSceneIndex({
        newValue: {
          node,
          index,
        },
        oldValue: {
          node,
          index: oldIndex,
        },
      }),
      record,
    })
  },

  rename({ state, commit }, { uuid, name, record = true }) {
    const node = state.sceneList.find((item) => item.uuid === uuid)
    if (name === name.uniqueName) {
      record = false
    }
    executeAction({
      action: {
        execute: ({ newValue }) => {
          const { uuid, name } = newValue
          nodeUtils.updateNodesStyle({
            nodes: [
              {
                uuid,
                uniqueName: name,
              },
            ],
          })
          store.commit('workspace/sceneManager/updateSceneList')
        },
        undo: ({ oldValue }) => {
          const { uuid, name } = oldValue
          nodeUtils.updateNodesStyle({
            nodes: [
              {
                uuid,
                uniqueName: name,
              },
            ],
          })
          store.commit('workspace/sceneManager/updateSceneList')
        },
        value: {
          newValue: {
            uuid,
            name,
          },
          oldValue: {
            uuid,
            name: node.uniqueName,
          },
        },
        methodName: 'renameAction',
      },
      record,
    })
  },

  /**
   * 通过场景模板添加场景
   * @param {*} 预设id
   */
  async addSceneByPrefab({ state }, { id, resSource }) {
    const res = await store.dispatch(
      'workspace/resourceManager/readComponent',
      { id, resSource },
    )
    res.data.type = AssetType.ASSET_PREFAB
    const _res = parseComponent(res)
    if (_res.errorMsg) {
      Message({
        message: _res.errorMsg,
        type: 'error',
        duration: 3 * 1000,
        showClose: true,
      })
    }
    const getNextSceneIndex = (node) => {
      const gamePlay = gameIframe.gamePlay
      const index = gamePlay.getChildIndex(node)
      return index + 1
    }
    const { node } = await store.dispatch(
      'workspace/game/prefab/addNewPrefab',
      {
        res: {
          name: _res.prefabName,
          json: _res.json,
          meta: _res.meta,
          projectKey: store.state.workspace.pid,
          files: _res.files,
          uuid2url: assets.uuid2UrlConf,
          type: _res.type,
          animationType: _res.animationType, // 用于识别龙骨类型的图集
        },
        isScenePrefab: true,
      },
    )
    const index = getNextSceneIndex(state.currentSceneNode)
    await executeAction({
      action: getAddSceneAction({
        newValue: {
          node,
          index,
          isSwitchScene: true,
          sceneType: SceneType.NORMAL,
        },
        oldValue: {
          node,
          sceneUuid: state.currentSceneNode ? state.currentSceneNode.uuid : '',
        },
      }),
      record: true,
    })
  },

  /**
   * 对场景进行截图
   */
  async beforeChangeToStory({ state, rootState, commit, dispatch }) {
    const currentOrientation = rootState.workspace.game.device.orientation
    const { sceneList, nodesLayout, sceneThumbnail, currentSceneNode } = state
    const toOrientation = currentOrientation === 1 ? 0 : 1
    const currentSceneUUID = currentSceneNode.uuid
    commit('updateIsCapturing', true)
    this.commit('workspace/lockPage')
    const { horizontal, portrait } = getSceneNeedCapture({
      nodesLayout,
      sceneList,
      sceneThumbnail,
    })
    let captureScenes = currentOrientation === 0 ? horizontal : portrait
    // 截图
    await dispatch('capture', {
      scenes: captureScenes,
      orientation: currentOrientation,
    })
    // 切换横竖屏
    await store.dispatch('workspace/game/device/updateOrientation', {
      value: toOrientation,
      record: false,
      changeOrientationForCaptureSceneImage: true,
    })
    await sleep(1500)
    captureScenes = toOrientation === 0 ? horizontal : portrait
    await dispatch('capture', {
      scenes: captureScenes,
      orientation: toOrientation,
    })
    // 切换回最初的场景和横竖屏
    await store.dispatch('workspace/game/device/updateOrientation', {
      value: currentOrientation,
      record: false,
      changeOrientationForCaptureSceneImage: true,
    })
    await dispatch('switchScene', {
      uuid: currentSceneUUID,
      record: false,
    })
    this.commit('workspace/unlockPage')
    commit('updateIsCapturing', false)
  },

  // 截取特定方向场景截图
  async captureOrientationSceneCover(
    { state, rootState, commit, dispatch },
    { orientation },
  ) {
    const { sceneList } = state
    commit('updateIsCapturing', true)
    this.commit('workspace/lockPage')
    // 截图
    for (const scene of sceneList) {
      const thumbnail = await dispatch('getThumb', {
        sceneNode: scene,
        orientation,
      })
      await store.dispatch('workspace/editorConfig/updateTargetNodeConfig', {
        node: scene,
        thumbnail,
      })
    }
    this.commit('workspace/unlockPage')
    commit('updateIsCapturing', false)
  },

  async capture({ state, dispatch }, { scenes, orientation, delay = 100 }) {
    for (const scene of scenes) {
      await dispatch('getThumb', { sceneNode: scene, orientation })
    }
    const { sceneList, nodesLayout, sceneThumbnail } = state
    const { horizontal, portrait } = getSceneNeedCapture({
      sceneList,
      nodesLayout,
      sceneThumbnail,
    })
    const leftScenes = orientation === 0 ? horizontal : portrait
    if (leftScenes.length > 0) {
      await dispatch('capture', {
        scenes: leftScenes,
        orientation,
        delay: delay + 100,
      })
    }
  },
  async getThumb(
    { state, dispatch, rootState },
    { sceneNode, orientation } = {},
  ) {
    sceneNode = sceneNode || state.currentSceneNode
    orientation =
      typeof orientation === 'undefined'
        ? rootState.workspace.game.device.orientation
        : orientation
    // 当有文本节点正处于双击后可编辑的状态时，此时如果不退出编辑状态，则截图时不包含该文本
    document.querySelector('#active-scene-container').click()
    const thumbnail = await this.dispatch(
      'workspace/game/captureCurrentScene',
      { captureSceneNode: sceneNode, captureOrientation: orientation },
    )
    dispatch('updateSceneProperty', {
      node: sceneNode,
      thumbnail,
      orientation,
    })
    return thumbnail
  },
  // 在故事板视图进行横竖屏切换的时候，需要补充截图(如在竖屏下进行编辑，需要补充横屏的截图)
  async updateCaptureThumbnail({ state, rootState, dispatch }) {
    const orientation = Number(rootState.workspace.game.device.orientation)
    const { sceneList, nodesLayout, sceneThumbnail, currentSceneNode } = state
    if (!currentSceneNode) {
      return
    }
    const currentSceneUUID = currentSceneNode.uuid
    if (
      rootState.workspace.storyboard.mode === storyboardConfig.modeTypes.story
    ) {
      const { horizontal, portrait } = getSceneNeedCapture({
        nodesLayout,
        sceneList,
        sceneThumbnail,
      })
      if (orientation === 0 && horizontal.length > 0) {
        await dispatch('capture', {
          scenes: horizontal,
          orientation: this.orientation,
        })
        await dispatch('switchScene', {
          // 切换回原场景
          uuid: currentSceneUUID,
          record: false,
        })
      }
      if (orientation === 1 && portrait.length > 0) {
        await dispatch('capture', {
          scenes: portrait,
          orientation: this.orientation,
        })
        await dispatch('switchScene', {
          // 切换回原场景
          uuid: currentSceneUUID,
          record: false,
        })
      }
    }
  },

  /**
   * 删除玩法场景，删除玩法需要同步删除绑定了玩法场景的普通模版，并且不可逆
   * 如果删除玩法场景会把所有普通场景都删除了，则需要重新建一个普通场景
   * @returns {Promise<void>}
   */
  async removePlayScene(
    { state, getters, dispatch, commit },
    { uuid, record = false },
  ) {
    const node = nodePool.find(uuid)
    const index = getters.playSceneList.findIndex((item) => {
      return item.uuid === node.uuid
    })
    let nextActiveSceneUUID = ''
    // 如果是玩法场景编辑界面下，并且玩法的数量大于 1，则需要删除之后切换选中的场景
    if (
      state.sceneEditType === SceneType.PLAY &&
      getters.playSceneList.length > 1
    ) {
      const nextActiveSceneIndex = index === 0 ? index + 1 : index - 1
      nextActiveSceneUUID = getters.playSceneList[nextActiveSceneIndex].uuid
    }

    const activeUuid = game.state.activeNode ? game.state.activeNode.uuid : ''
    const currentSceneUUID = state.currentSceneNode.uuid

    const normalBindedScene = getters.normalSceneList.filter((scene) => {
      const normalSceneConfig = sceneConfigScript.getScript(scene)
      return normalSceneConfig.playUUID === node.uuid
    })
    const toBeRemoveScenes = [node].concat(normalBindedScene)
    const eventsOnNode = {}
    const eventsToNode = {}
    const nodesLayout = {}
    const nodeIndex = {}
    let newNode = null
    toBeRemoveScenes.forEach((item) => {
      eventsOnNode[item.uuid] = getEventsOnNode({ sceneId: item.uuid })
      eventsToNode[item.uuid] = getEventsToNode({ nodeId: item.uuid })
      nodesLayout[item.uuid] = getNodesLayoutBySceneId({
        sceneId: item.uuid,
        nodesLayout: state.nodesLayout,
      })
      nodeIndex[item.uuid] = state.sceneList.findIndex((temp) => {
        return item.uuid === temp.uuid
      })
    })

    const normalUUID = normalBindedScene.map((scene) => scene.uuid)

    // 删除场景后，普通场景列表
    const afterRemoveScenes = getters.normalSceneList.filter(
      (scene) => normalUUID.indexOf(scene.uuid) === -1,
    )

    // 如果删除之后没有普通场景，则新建一个；并且如果在编辑玩法场景中，无需要选中，如果在普通场景编辑界面，需要选中该新增的场景
    if (afterRemoveScenes.length < 1) {
      newNode = scene.add({
        uniqueName: getSceneUniName(state.sceneList),
      })
    }

    // 根据移除场景排序，保证按顺序移除
    const sortBeRemove = _.sortBy(toBeRemoveScenes, (o) => {
      return state.sceneList.findIndex((item) => {
        return item.uuid === o.uuid
      })
    })

    await executeAction({
      action: getRemovePlaySceneAction({
        newValue: {
          nodes: _.clone(sortBeRemove).reverse(),
          newNode,
          activeSceneUuid: nextActiveSceneUUID,
          activeUuid,
        },
        oldValue: {
          nodes: sortBeRemove,
          newNode,
          parent: node.parent,
          nodeIndex,
          activeSceneUuid: currentSceneUUID,
          activeUuid,
          // activeUuids: game.state.activeNodeList.map((item) => item.uuid),
          nodesLayout,
          eventsOnNode,
          eventsToNode,
        },
      }),
      record: true,
    })
  },
}
